import { useEffect } from "react";
function useOnScroll(target, onScroll) {
  useEffect(() => {
    if (!target) return;
    function handleOnScroll() {
      if (!target) return;
      onScroll?.({ left: target.scrollLeft, top: target.scrollTop }, target);
    }
    target.addEventListener("scroll", handleOnScroll);
    return () => {
      target.removeEventListener("scroll", handleOnScroll);
    };
  }, [target, onScroll]);
}
export {
  useOnScroll
};
//# sourceMappingURL=useOnScroll.js.map
